
exports.install = function (Vue, options) {
    Vue.prototype.GetRequest = function (url) {//全局函数1
        var url = url; //获取url中"?"符后的字串
        console.log(url);
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
            var str = url.substr(url.indexOf("?") + 1);
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
            }
        }
        return theRequest;
    };
    //判断浏览器类型
    Vue.prototype.getborwser = function () {
        var ua = window.navigator.userAgent.toLowerCase()
        var b = '';
        if (ua.indexOf('micromessenger') > -1) {
            b = 'wechat'
        } else if (ua.indexOf('qq') > -1) {
            b = 'qq'
        } else if (ua.indexOf('weibo') > -1) {
            b = 'weibo'
        } else {
            b = ''
        }
        return b;
    }




    /**************************************时间格式化处理************************************/
    Vue.prototype.dateFormat = function (date, fmt) { 
        
        var o = {
            "M+": date.getMonth() + 1,                 //月份   
            "d+": date.getDate(),                    //日   
            "h+": date.getHours(),                   //小时   
            "m+": date.getMinutes(),                 //分   
            "s+": date.getSeconds(),                 //秒   
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
            "S": date.getMilliseconds()             //毫秒   
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }


    Vue.prototype.dateDiff=function(start,end){
        debugger
        var startTime = start;
        var start = new Date(startTime.replace("-", "/").replace("-", "/"));
        var endTime = end;
        var end = new Date(endTime.replace("-", "/").replace("-", "/"));
        if (end <= start) {
            return false;
        }
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/js/common.js